import React, { useEffect } from "react";
import { searchParamToObject } from "../../helpers/SearchParamHelper";
import { useSearchParams } from "react-router-dom";

type HighlightedTextProps = {
  text: string;
  subtext?: string;
  highlightColor?: string;
  useParam?: string;
};

const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  subtext,
  highlightColor = "yellow",
  useParam,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const getSubtext = React.useCallback(() => {
    if (subtext) {
      return subtext;
    }
    const searchParamsObject = searchParamToObject(searchParams);
    return searchParamsObject[useParam ?? "search"] ?? "";
  }, [searchParams, subtext, useParam]);
  const [_subtext, _setSubtext] = React.useState<string>(getSubtext());

  useEffect(() => {
    _setSubtext(getSubtext());
  }, [searchParams, subtext, useParam]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!_subtext) return <span>{text}</span>;

  const regex = new RegExp(`(${_subtext})`, "ig");
  const parts = text.split(regex);

  return (
    <span>
      {parts.map((part, index) =>
        part.toLowerCase() === _subtext.toLowerCase() ? (
          <mark
            key={index}
            style={{ backgroundColor: highlightColor, padding: "0 2px" }}
          >
            {part}
          </mark>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </span>
  );
};

export default HighlightedText;
